import { render, staticRenderFns } from "./invoicesubmissionmanagementtable.vue?vue&type=template&id=ca98d2ce&scoped=true&"
import script from "./invoicesubmissionmanagementtable.vue?vue&type=script&lang=js&"
export * from "./invoicesubmissionmanagementtable.vue?vue&type=script&lang=js&"
import style0 from "./invoicesubmissionmanagementtable.vue?vue&type=style&index=0&id=ca98d2ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca98d2ce",
  null
  
)

export default component.exports